export default __webpack_public_path__ + "mini-icon-os-windows@2x.png";